var path = './bim.select/bim-select-item.template.html';
var html = "<span\n    class=\"bim-select-item\"\n    title=\"{{ item.text }}\">{{ item.text }}</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;